import { h } from "preact";
import { useEffect, useState } from "preact/hooks";
import { useDispatch, useSelector } from "react-redux";

import i18n from "../../i18n";
import { getValue } from "../../helpers.js";
import { fetchAll } from "../../store/documentsSlice";

import Button from "../Button.jsx";
import HeaderIcon from "../HeaderIcon.jsx";
import List from "../List.jsx";
import ListItem from "../ListItem.jsx";
import WhitepaperTeaser from "../WhitepaperTeaser.jsx";

function getDocumentByFieldName(files, key) {
  return files.find((file) => file.fileId === `${key}.pdf`);
}

export default {
  qualifications_recognition_start: ({ onNext }) => {
    const [loaded, setLoaded] = useState(false);
    const [recognitionFile, setRecognitionFile] = useState(null);
    const userFiles = useSelector((state) => state.documents.userFiles);
    const dispatch = useDispatch();

    useEffect(() => {
      if (userFiles.length == 0 && !loaded) {
        dispatch(fetchAll());
        setLoaded(true);
      }
    }, [userFiles, loaded]);

    useEffect(() => {
      setRecognitionFile(getDocumentByFieldName(userFiles, "recognition_pdf"));
    }, [userFiles]);

    return (
      <section class="task-page">
        <HeaderIcon>recognition_procedure</HeaderIcon>
        <h1 class="task-page__headline">Recognition procedure</h1>

        <div class="task-page__content">
          <p class="t-body3">
            The competent authority will handle your recognition of
            qualifications.
          </p>

          <List class="mb-32">
            <ListItem number={1}>
              Follow the procedure of the recognition portal below.
            </ListItem>
            <ListItem number={2}>
              Get the required documents for your application.
            </ListItem>
            <ListItem number={3} class="mb-16">
              Apply to the competent authority.
            </ListItem>

            {recognitionFile && (
              <ListItem
                overline={`File from ${i18n.t(
                  "tasks.regulated_profession_check.title"
                )}`}
                iconFront="picture_as_pdf"
                link={recognitionFile.src}
              >
                {recognitionFile.title}
              </ListItem>
            )}
          </List>

          <p>
            <strong>Please note: </strong>The processing can take up to three
            months.
            <br />
            Has the competent authority informed you about the result? Please
            pass this information on to Nioomi.
          </p>
        </div>

        <div class="task-page__buttons">
          <Button onClick={onNext}>{i18n.t("actions.enter_result")}</Button>
        </div>
      </section>
    );
  },
  qualifications_recognition_result: ({ answers, onNext, onRestart }) => {
    return (
      <section class="task-page">
        <HeaderIcon>recognition_procedure</HeaderIcon>
        <h1 class="task-page__headline">
          {i18n.t("pages.common.result_title")}
        </h1>

        <div class="task-page__content">
          <List class="mb-32">
            {getValue(answers.outcomeQualification) ? (
              <ListItem
                iconFront="check"
                secondLine="Your professional qualification is equivalent to the relevant German reference occupation, and you meet the further criteria."
              >
                Recognition
              </ListItem>
            ) : (
              <ListItem
                iconFront="warning"
                secondLine="Your professional qualification is not equivalent, or you do not meet the further criteria."
              >
                No Recognition
              </ListItem>
            )}
          </List>

          <WhitepaperTeaser
            class="mt-32"
            title="Qualification"
            description={i18n.t("whitepaperTeaser.qualification")}
            whitepaperId="degree-recognition-in-germany"
          />
        </div>

        <div class="task-page__buttons">
          <Button onClick={onNext}>{i18n.t("actions.done")}</Button>

          <Button text onClick={onRestart}>
            {i18n.t("actions.discard_result")}
          </Button>
        </div>
      </section>
    );
  },
};
